import * as Sentry from '@sentry/nextjs';
import { generateDataPoint } from '../diagnostics';
import { EventFlow } from '../dto/events';

/**
 * Generates a log entry for diagnosing/monitoring specific issues. This call
 * will additionally send a Sentry alert if the error param is provided.
 * Note: The resulting data point will have the 'track' `EventType`
 * @param action The `EventFlow` flow to create a log entry/Sentry alert around.
 * @param params A databag of relevant fields to capture in this log.
 * @param error An error to log. If this param is provided,
 * a Sentry alert will be fired with the error and params.
 */
export const logClientDataPoint = (
  action: EventFlow,
  params?: Record<string, any>,
  error?: string
) => {
  const dp = JSON.stringify(generateDataPoint('track', action, params, error));

  if (error) {
    const e = new Error(dp);
    e.name = `ManualClientError: ${action}`;
    console.error(e);
    Sentry.captureException(e);
  } else {
    Sentry.captureMessage(dp);
  }
};
